export default "__VITE_ASSET__C9bTwAf1__"